import { contextFactory } from './createContext';

export const {
  Provider: AvatarViewerProvider,
  useCtx: useAvatarViewer,
  useCtxSelector: useAvatarViewerSelector,
} = contextFactory('AvatarViewerContext');
